import DateTimeUtils from '@/utils/datetime';
import BaseProxy from './base-proxy';

/**
 * Class StatisticsProxy
 */
class StatisticsProxy extends BaseProxy {
  /**
   * Constructor.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/invoice-robotics-api/api', parameters);
  }

  getCashFlows(payload, options = {}) {
    const data = {
      from_date: DateTimeUtils.formatDate(payload.from_date, 'YYYY-MM-DD'),
      to_date: DateTimeUtils.formatDate(payload.to_date, 'YYYY-MM-DD'),
      based_on: payload.base_on,
      customer_id: payload.customer_id,
      vendor_id: payload.vendor_id,
      directories: payload.directories,
      based_on_paid: payload.based_on_paid,
      tags: payload.tags,
      status: payload.status,
      invoice_type: payload.invoice_type,
      invoice_status_from_tax_agency: payload.invoice_status_from_tax_agency,
      invoices_suspected: payload.invoices_suspected,
    };
    if (!data.from_date) {
      const d = new Date();
      data.from_date = `${d.getFullYear() - 1}-01-01`;
    }
    if (!data.to_date) {
      data.to_date = DateTimeUtils.formatDate(new Date(), 'YYYY-MM-DD');
    }
    return this.submit('post', `${this.endpoint}/statistics-cashflows`, data, options);
  }

  getStatistics(payload, options = {}) {
    const data = {
      ...payload,
      start_date: DateTimeUtils.formatDate(payload.start_date, 'YYYY-MM-DD'),
      end_date: DateTimeUtils.formatDate(payload.end_date, 'YYYY-MM-DD'),
    };
    return this.submit('post', `${this.endpoint}/v2/statistics/invoices`, data, options);
  }

  getInvoicesStatistic(payload, options = {}) {
    const data = {
      ...payload,
      start_date: DateTimeUtils.formatDate(payload.start_date, 'YYYY-MM-DD'),
      end_date: DateTimeUtils.formatDate(payload.end_date, 'YYYY-MM-DD'),
    };
    return this.submit('post', `${this.endpoint}/v2/statistics/invoices/statistic-new-and-risk-invoices`, data, options);
  }

  getDiscrepancies(payload, options = {}) {
    const data = {
      ...payload,
      start_date: DateTimeUtils.formatDate(payload.start_date, 'YYYY-MM-DD'),
      end_date: DateTimeUtils.formatDate(payload.end_date, 'YYYY-MM-DD'),
    };
    return this.submit('post', `${this.endpoint}/v2/statistics/invoices/discrepancy`, data, options);
  }

  getCompanies(payload, options = {}) {
    const params = {
      search_text: payload.search_text,
      debt: payload.debt,
      start_date: payload.start_date,
      end_date: payload.end_date,
      page: payload.page,
      page_size: payload.page_size,
    };
    return this.submit('post', `${this.endpoint}/v2/statistics/${payload.type}`, params, { showResponseStatus: true, ...options });
  }

  getTagsStatistic(payload) {
    const params = {
      start_date: payload.start_date,
      end_date: payload.end_date,
    };
    return this.submit('post', `${this.endpoint}/v2/statistics/tags`, params, {});
  }

}

export default StatisticsProxy;



// WEBPACK FOOTER //
// ./src/store/proxies/statistics-proxy.js